import React from 'react';
import { styled } from '@mui/material/styles';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Tooltip from '@mui/material/Tooltip';

const StyledFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  zIndex: theme.zIndex.speedDial,
}));

function FloatingActionButton({ onClick, tooltip = '' }) {
  return (
    <Tooltip title={tooltip} placement="left">
      <StyledFab 
        color="primary" 
        aria-label="add"
        onClick={onClick}
      >
        <AddIcon />
      </StyledFab>
    </Tooltip>
  );
}

export default FloatingActionButton;